export default __webpack_public_path__ + "static/media/nitro.2d289b63.svg";